import React, {useMemo, useState} from "react";
import Layout from "@hoc/layouts/Layout";
import PageHeader from "@components/Pages/PageHeader";
import PageListItem from "@components/Pages/ListItem";
import Pagination from "@components/Pages/Pagination";
import {useSelector} from "react-redux";
import _ from "lodash";
import {useTranslation} from "react-i18next";
import {getMediaUrl} from "@utils/helpers";

const PAGE_SIZE = 5;

// The overview keeps general documents; assigned documents belong to their section.
export const getGeneralTransparencyDocuments = (documents) => (documents || []).filter(item =>
  item.category === null || item.category === undefined || item.category === '' || Number(item.category) === 1
);


const TransparencyProgramPage = () => {
  const {t, i18n} = useTranslation()
  const language = i18n.language;
  const allDocuments = useSelector((state) =>
    _.get(state, "generalState.transparencyPrograms", [])
  );

  const data = useMemo(() => getGeneralTransparencyDocuments(allDocuments), [allDocuments]);

  const [currentPage, setCurrentPage] = useState(1);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PAGE_SIZE;
    const lastPageIndex = firstPageIndex + PAGE_SIZE;
    return data.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, data]);

  return (
    <Layout>
      <div className={'my-10 w-full lg:w-4/5 px-3 sm:px-5 md:px-10 lg:px-0 mx-auto'}>
        <PageHeader title={t('publications.transparencyProgram')} />
        <PageListItem name={t('publications.transparencyProgram')} to={'/publications/transparency-program/show'} />
        {currentTableData.map((item) => (
          <PageListItem key={item.id} isPdf name={item[`title_${language}`]} to={getMediaUrl(item)} />
        ))}
        <Pagination
          currentPage={currentPage}
          totalCount={data.length}
          pageSize={PAGE_SIZE}
          onPageChange={setCurrentPage}
        />
      </div>
    </Layout>
  );
}

export default TransparencyProgramPage;
